import { createAction, props } from "@ngrx/store";
import { Lot } from "src/app/+state/lots/lot";
import { LotsTableFilter } from "./lot.reducers";
import { HarvestAmount } from "src/app/honey-house/harvest-amount";
import { BeekeeperProducts } from "src/app/honey-house/beekeeper-products";

export const fetchLots = createAction('[Lots] fetch lots');
export const fetchAmounts = createAction('[Lots] fetch harvest amounts ');

export const fetchLotsSuccess = createAction(
  '[Lots] fetch lots success',
  props<{lots: Lot[]}>()
);

export const fetchLotsError = createAction(
  '[Lots] fetch lots error',
  props<{error: any}>()
);

export const lotSubmitted = createAction(
  '[Lots] lot submitted',
  props<{lot: Lot, redirectTo: string}>()
);

export const lotSubmittedSuccess = createAction(
  '[Lots] lot submitted success',
  props<{lot: Lot, redirectTo: string}>()
);

export const lotSubmittedError = createAction(
  '[Lots] lot submitted error',
  props<{error: any}>()
);

export const fetchLot = createAction(
  '[Lots] fetch lot',
  props<{lotId: string}>()
);

export const fetchLotSuccess = createAction(
  '[Lots] fetch lot success',
  props<{lot: Lot}>()
);

export const fetchLotError = createAction(
  '[Lots] fetch lot error',
  props<{error: any}>()
);

export const amountsFetched = createAction('[Lots] fetch amounts ok', props<{response: any}>());
export const amountsFetchedError = createAction('[Lots] fetch amounts error', props<{error: any}>());

export const deleteLot = createAction(
  '[Lots] delete lot',
  props<{lotId: string, redirectTo?: string}>()
);

export const deleteLotSuccess = createAction(
  '[Lots] delete lot success',
  props<{redirectTo?: string}>()
);

export const deleteLotError = createAction(
  '[Lots] delete lot error'
);

export const updateTableFilter = createAction(
  '[Lots] update table filter',
  props<{tableFilter: LotsTableFilter}>()
);

//
// Assing / create / manage harvest entries
//
export const assignHarvest = createAction(  // atm just for manual creation of harvest amount in edit lot
  '[Lots] assign harvest',
  props<{harvestAmount: HarvestAmount}>()
);

export const removeHarvest = createAction(   // atm just for manual creation of harvest amount in edit lot
  '[Lots] removeHarvest',
  props<{harvestAmount: HarvestAmount}>()
);

export const updateHarvestOk = createAction(
  '[Lots] manage harvest ok',
  props<{harvestAmount: HarvestAmount}>()
);

export const updateHarvestErr = createAction(
  '[Lots] manage harvest fail',
  props<{error: any}>()
);

//
// Connect lab result
//
export const connectLabResult = createAction(
  '[Lots] connect lab result',
  props<{lotId: string, labresultSecretCode: string}>()
);

export const connectLabResultSuccess = createAction(
  '[Lots] connect lab result success',
  props<{lot: Lot}>()
);

export const connectLabResultError = createAction(
  '[Lots] connect lab result error',
  props<{error: any}>()
);

export const unsetLabConnect = createAction(
  '[Lots] unset lab result',
  props<{lot: Lot}>()
);

export const labConnectOk = createAction(
  '[Lots] update lab result ok',
  props<{lot: Lot}>()
);

export const labConnectErr = createAction(
  '[Lots] update lab result err',
  props<{error: any}>()
);

// static connectLotRequest = createAction(
//   '[Lots] connect lot request',
//   props<{lotId: string, lotNr: string}>()
// );

// static connectLotResult = createAction(
//   '[Lots] connect lot result',
//   props<{lot: Lot, result: string}>()
// );

// static connectLotFail = createAction(
//   '[Lots] connect lot error',
//   props<{error: any}>()
// );

//
// Beekeeper Products
//
export const fetchBeekeeperProducts = createAction('[BeekeeperProducts] fetch beekeeper products');

export const fetchBeekeeperProductsSuccess = createAction(
  '[BeekeeperProducts] fetch beekeeper products success',
  props<{beekeeperProducts: BeekeeperProducts[]}>()
);

export const fetchBeekeeperProductsError = createAction(
  '[BeekeeperProducts] fetch beekeeper products error',
  props<{error: any}>()
);

export const beekeeperProductsSubmitted = createAction(
  '[BeekeeperProducts] beekeeper products submitted',
  props<{beekeeperProducts: BeekeeperProducts}>()
);

export const beekeeperProductsSubmittedSuccess = createAction(
  '[BeekeeperProducts] beekeeper products submitted success',
  props<{beekeeperProducts: BeekeeperProducts}>()
);

export const beekeeperProductsSubmittedError = createAction(
  '[BeekeeperProducts] beekeeper products submitted error',
  props<{error: any}>()
);